import React from 'react';
import styled from 'styled-components';
import SmallLoader from './SmallLoader';

interface Props {
   onClick: () => void;
   visible: boolean;
   loading?: boolean;
}

const ClearInputButton: React.FC<Props> = ({ onClick, visible, loading }): JSX.Element => (
   <Button visible={visible} onClick={onClick}>
      {loading ? (
         <SmallLoader size={16} />
      ) : (
         <svg viewBox="0 0 24 24" width="22" height="22" fill="#aaa">
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
         </svg>
      )}
   </Button>
);

export default ClearInputButton;

const Button = styled.button.attrs({ type: 'button' })<{ visible: boolean }>`
   display: ${({ visible }) => (visible ? 'inline-block' : 'none')};
   position: absolute;
   top: 8;
   right: 5;
   z-index: 30;
   margin-left: 15px;
   border: none;
   cursor: pointer;
   background-color: transparent;
   @supports (-moz-appearance: none) {
      background-color: transparent !important;
   }
   :focus {
      border: none;
   }
   @media only screen and (max-width: 415px) {
      right: 120px;
      margin-left: unset;
   }
`;
